import React from 'react';
import Button from 'components/Button';
import { buildPaginationWindow } from 'utils/paginationWindow';
import './ListingPagination.css';

export type ListingPaginationProps = {
  currentPage: number;
  totalPages: number;
  displayStart: number;
  displayEnd: number;
  onPageChange: (page: number) => void;
  className?: string;
};

export default function ListingPagination({
  currentPage,
  totalPages,
  displayStart,
  displayEnd,
  onPageChange,
  className = '',
}: ListingPaginationProps) {
  if (totalPages <= 1) return null;

  const windowPages = buildPaginationWindow(currentPage, totalPages);
  const pageItems: React.ReactNode[] = [];

  windowPages.forEach((number, index) => {
    const prev = windowPages[index - 1];
    if (prev != null && number - prev > 1) {
      pageItems.push(
        <li key={`ellipsis-${number}`} className="page-item disabled sb-listing-pagination__ellipsis-item">
          <span className="page-link">…</span>
        </li>
      );
    }
    pageItems.push(
      <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
        <Button
          className="page-link"
          onClick={() => onPageChange(number)}
          aria-current={currentPage === number ? 'page' : undefined}
        >
          {number}
        </Button>
      </li>
    );
  });

  return (
    <div className={`sb-listing-pagination ${className}`.trim()}>
      <nav aria-label="İlan sayfaları">
        <ul className="pagination justify-content-center flex-wrap mb-0">
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <Button
              className="page-link"
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
              aria-label="Önceki sayfa"
            >
              <i className="fas fa-chevron-left me-1" aria-hidden="true" />
              Önceki
            </Button>
          </li>
          {pageItems}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <Button
              className="page-link"
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              aria-label="Sonraki sayfa"
            >
              Sonraki
              <i className="fas fa-chevron-right ms-1" aria-hidden="true" />
            </Button>
          </li>
        </ul>
      </nav>
      <p className="sb-listing-pagination__summary text-center text-muted mb-0">
        Sayfa <strong>{currentPage}</strong> / <strong>{totalPages}</strong>
        {displayEnd >= displayStart ? (
          <>
            {' '}
            · <strong>{displayStart}-{displayEnd}</strong> arası gösteriliyor
          </>
        ) : null}
      </p>
    </div>
  );
}
